import React from 'react';
import s from '../../pages/PDV.module.css';

export default function ModalCliente({ modalCliente, setModalCliente, buscaRef, buscaCliRef, buscaCliente, handleBuscaClienteChange, buscandoCli, clientes, idxCli, selecionarCliente, subModalNovoCli, setSubModalNovoCli, novoCliNome, setNovoCliNome, novoCliCpf, setNovoCliCpf, novoCliFone, setNovoCliFone, erroNovoCli, setErroNovoCli, salvarNovoCli, salvandiNovoCli, limparCliente }) {
  // Mantém a linha selecionada visível ao navegar com as setas
  const linhaSelRef = React.useRef(null);
  React.useEffect(() => {
    linhaSelRef.current?.scrollIntoView?.({ block: 'nearest' });
  }, [idxCli]);

  if (!modalCliente) return null;
  return (
        // zIndex alto: abre POR CIMA de qualquer modal do PDV (F9/F7 usam 1000+
        // na mesma classe .modalOverlay — empate de z-index deixa a ordem no DOM
        // decidir quem fica visível, e o F10 pode ser aberto de dentro do F9).
        <div
          className={s.modalOverlay}
          style={{ zIndex: 99000 }}
          onClick={() => { setModalCliente(false); buscaRef.current?.focus(); }}
        >
          <div className={s.modalCliente} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>F10 — Selecionar Cliente</span>
              <button
                className={s.modalClose}
                onClick={() => { setModalCliente(false); buscaRef.current?.focus(); }}
              >✕</button>
            </div>

            <div className={s.modalBody}>
              <input
                ref={buscaCliRef}
                className={s.inputBuscaCli}
                placeholder="Nome, CPF/CNPJ ou telefone…"
                value={buscaCliente}
                onChange={handleBuscaClienteChange}
                autoComplete="off"
              />
              {buscandoCli && <p className={s.buscandoMsg}>Buscando…</p>}
              <div className={s.listaClientes}>
                {clientes.map((c, idx) => (
                  <div key={c.id}
                    ref={idxCli === idx ? linhaSelRef : null}
                    className={`${s.clienteItem} ${idxCli === idx ? s.clienteItemSel : ''}`}
                    onClick={() => selecionarCliente(c)}>
                    <span style={{ display: 'flex', alignItems: 'baseline', gap: 8, minWidth: 0 }}>
                      <span style={{ fontFamily: 'monospace', fontSize: 11, color: '#888', minWidth: 30, flexShrink: 0 }}>
                        {c.codigo ?? '—'}
                      </span>
                      <span className={s.clienteItemNome}>{c.nome}</span>
                    </span>
                    <span className={s.clienteItemDoc}>{c.cpf_cnpj || '—'}</span>
                  </div>
                ))}
                {buscaCliente.length > 0 && !buscandoCli && clientes.length === 0 && (
                  <p className={s.semResultado}>Nenhum cliente encontrado.</p>
                )}
              </div>
            </div>

            {subModalNovoCli && (
              <div style={{ borderTop: '1px solid #ddd', padding: '12px 16px', background: '#f9fafb' }}>
                <div style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 10, color: '#1e3a5f' }}>
                  Novo Cliente (cadastro rápido)
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 12px', marginBottom: 8 }}>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={{ fontSize: 11, color: '#555' }}>Nome *</label>
                    <input
                      autoFocus
                      type="text"
                      value={novoCliNome}
                      onChange={e => setNovoCliNome(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && salvarNovoCli()}
                      placeholder="Nome do cliente"
                      style={{ width: '100%', padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4, boxSizing: 'border-box' }}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: '#555' }}>CPF / CNPJ</label>
                    <input
                      type="text"
                      value={novoCliCpf}
                      onChange={e => setNovoCliCpf(e.target.value)}
                      placeholder="Opcional"
                      style={{ width: '100%', padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4, boxSizing: 'border-box' }}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: '#555' }}>Telefone</label>
                    <input
                      type="text"
                      value={novoCliFone}
                      onChange={e => setNovoCliFone(e.target.value)}
                      placeholder="Opcional"
                      style={{ width: '100%', padding: '5px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4, boxSizing: 'border-box' }}
                    />
                  </div>
                </div>
                {erroNovoCli && (
                  <p style={{ color: '#b91c1c', fontSize: 12, margin: '4px 0 8px' }}>{erroNovoCli}</p>
                )}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    onClick={salvarNovoCli}
                    disabled={salvandiNovoCli}
                    style={{ padding: '6px 16px', fontSize: 13, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold' }}
                  >{salvandiNovoCli ? 'Salvando...' : 'Salvar e Selecionar'}</button>
                  <button
                    onClick={() => { setSubModalNovoCli(false); setErroNovoCli(''); }}
                    style={{ padding: '6px 14px', fontSize: 13, background: '#f5f5f5', border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer' }}
                  >Cancelar</button>
                </div>
              </div>
            )}

            <div className={s.modalFooter}>
              <button
                className={s.btnConsumidor}
                title="Volta ao cliente padrão (1 — VENDA CONSUMIDOR)"
                onClick={() => { setSubModalNovoCli(false); limparCliente(); }}
              >
                Venda Consumidor (padrão)
              </button>
              <button
                style={{ padding: '6px 14px', fontSize: 13, background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold' }}
                onClick={() => { setNovoCliNome(''); setNovoCliCpf(''); setNovoCliFone(''); setErroNovoCli(''); setSubModalNovoCli(true); }}
              >
                + Novo Cliente
              </button>
              <button
                className={s.btnCancelarModal}
                onClick={() => { setSubModalNovoCli(false); setModalCliente(false); buscaRef.current?.focus(); }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
  );
}
